import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface OptimizerSessionTokenState {
  OptimizerSessionToken: null | number;
}

const initialState: OptimizerSessionTokenState = {
  OptimizerSessionToken: null,
};

const OptimizerSessionTokenSlice = createSlice({
  name: "OptimizerSessionToken",
  initialState,
  reducers: {
    setOptimizerGridcoSessionToken: (state, action: PayloadAction<number>) => {
      state.OptimizerSessionToken = action.payload;
    },
    clearOptimizerGridcoSessionToken: (state) => {
      state.OptimizerSessionToken = null;
    },
  },
});

export const { setOptimizerGridcoSessionToken, clearOptimizerGridcoSessionToken } = OptimizerSessionTokenSlice.actions;
export default OptimizerSessionTokenSlice.reducer;
